<template>
  <div>
    <d-row lg="12">
      <d-col class="col-lg-12">
        <h5>Service Locations</h5>
      </d-col>
    </d-row>
    <d-row lg="12">
      <d-col class="col-lg-12">
        <template v-for="serviceLocation in parking.serviceLocations">
          <service-location :service-location="serviceLocation" :providerID="parking.id" />
        </template>
        <div v-if="parking.serviceLocations.length === 0" class="provider-page__no-content">
          Has no Service Location yet
        </div>

        <div class="provider-page__create-label">Create new Service Location</div>
        <div class="provider-page__create">

          <div class="provider-page__type-select">
            <d-select v-model="createType">
              <option value="6dvgln4ofde">Shuttle</option>
              <option value="8ftpe6gpdvi">Valet</option>
              <option value="hg49xy82wi">Park & Walk</option>
              <option value="lqbmkqreh">Park & Taxi</option>
            </d-select>
          </div>

          <d-button theme="primary" @click="createProviderPage" :disabled="!canInteract">Create page</d-button>

        </div>

        <v-feedback :bus="bus"></v-feedback>

      </d-col>
    </d-row>

  </div>

</template>

<script>
	import ServiceLocation from "~/components/parkings/ServiceLocation";
  import Vue from "vue";
  export default {
		name: "ServiceLocations",
    components: {ServiceLocation},
    props: {
      parking: {
        required: true,
        type: Object,
      },
    },
    data: function () {
      return {
        bus: new Vue(),
        createType: '6dvgln4ofde', // Default shuttle
        canInteract: true,
      }
    },

    methods: {
      createProviderPage: async function () {

        const variables = {
          provider: this.parking.id,
          type: this.createType,
          available: true,
          availability: 0
        };

        await this.$apollo.mutate({
          mutation: require('~/graphql/CreateServicelocation.gql'),
          variables: variables,
        }).then((response) => {

          new Promise((resolve, reject) => {
            if(response.data.createServiceLocation.success) resolve()
            else reject(response.data)
          }).then(() => {
            this.bus.$emit('submitData', {type: 'success', message: 'A new service location was created.'});
            window.location.reload(true)
          }).catch((error) => {

            error.createServiceLocation.errors.forEach((error) => {
              this.bus.$emit('submitData', {type: 'warning', message: error});
            })

            this.canInteract = true
          })

        }).catch((error) => {
          this.bus.$emit('submitData', {type: 'warning', message: 'Something went wrong creating the provider page'});
          this.canInteract = true
        });
      }
    }
	}
</script>



